<div class="table-responsive">
  <table #table class="table table-borderless table-hover table-sm mb-0">
    <ng-container *ngIf="columns.length">
      <thead class="thead-dark">
        <tr>
          <th
            *ngFor="let column of columns"
            [ngClass]="[column.size, column.class || '']"
            (click)="shortColumnFunction(column.short_by)"
            data-toggle="tooltip"
            [title]="column.tooltip_text ? column.tooltip_text : ''">
            {{ column.label || '' }}
            <ng-container *ngIf="column.icon?.length">
              <i [ngClass]="[column.icon]"></i>
            </ng-container>
            <ng-container *ngIf="column.show_checkbox">
              <form-checkbox #checkboxElement class="dark m-2" [checked]="!!(ourDataService.is_under_writting_processing$ |async) || !!(paginatedDataService.is_all_checked$ | async)" (change)="toggleAllCheckbox($event)"></form-checkbox>
            </ng-container>
            <ng-container *ngIf="column.short_by === sort_by">
              <i class="brand-icon Icons_A-to-Z" *ngIf="order_by === 'asc'"></i>
              <i class="brand-icon Icons_Z-to-A" *ngIf="order_by === 'desc'"></i>
            </ng-container>
          </th>
        </tr>
      </thead>
    </ng-container>

    <ng-content select="thead"></ng-content>
    <ng-content></ng-content>
    <ng-content select="tfoot"></ng-content>
  </table>
</div>
